import { a as _slicedToArray } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default, { useState } from 'react';
import PropTypes from 'prop-types';
import Title from './Title.js';
import { I as Icon } from './index-11bc5ac3.js';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import './_commonjsHelpers-17042db9.js';
import 'moment';

function FeedbackMessage(props) {
  var title = props.title,
    message = props.message,
    extraContent = props.extraContent,
    icon = props.icon,
    inlineBlock = props.inlineBlock,
    align = props.align,
    className = props.className,
    onClick = props.onClick,
    onCloseClick = props.onCloseClick,
    closeIcon = props.closeIcon,
    compact = props.compact,
    withColumns = props.withColumns;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showFeedbackMessage = _useState2[0],
    setShowFeedbackMessage = _useState2[1];
  var type = props.type;
  var allowedType = ['info', 'warning', 'danger', 'error', 'success', 'neutral'];
  type = allowedType.some(function (validType) {
    return validType === type;
  }) ? "".concat(type) : '';
  function handleCloseIcon() {
    setShowFeedbackMessage(false);
    onCloseClick();
  }
  var feedbackMessageClasses = "bf-feedback-message\n        bf-feedback-message-".concat(type, "\n        ").concat(compact ? 'bf-feedback-message-compact' : '', "\n        ").concat(withColumns ? 'bf-feedback-message-with-columns' : '', "\n        ").concat(inlineBlock ? 'bf-feedback-message-inline-block' : '', "\n        bf-feedback-message-align-").concat(align, "\n        ").concat(className, "\n    ");
  return showFeedbackMessage && /*#__PURE__*/React__default.createElement("div", {
    className: feedbackMessageClasses,
    onClick: onClick
  }, icon ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-feedback-message-icon-wrapper"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: icon,
    size: "large",
    className: "bf-feedback-message-icon"
  })) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-feedback-message-content"
  }, title ? /*#__PURE__*/React__default.createElement(Title, {
    size: compact ? 'normal' : 'medium',
    className: "bf-feedback-message-title",
    content: title
  }) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-feedback-message-text"
  }, message, props.children), extraContent ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-feedback-message-extra-content"
  }, extraContent) : null), closeIcon ? /*#__PURE__*/React__default.createElement("div", {
    onClick: handleCloseIcon,
    className: "bf-feedback-message-close-wrapper"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "bf-icon-times",
    className: "bf-feedback-message-close"
  })) : null);
}
FeedbackMessage.defaultProps = {
  extraContent: null,
  icon: '',
  message: '',
  title: '',
  type: 'neutral',
  align: 'left',
  closeIcon: false,
  className: '',
  onClick: function onClick() {},
  onCloseClick: function onCloseClick() {},
  compact: false,
  withColumns: false,
  inlineBlock: false
};
FeedbackMessage.propTypes = {
  /**
  FeedbackMessage title
   */
  title: nodeOrStringProp,
  /**
  FeedbackMessage content
   */
  message: nodeOrStringProp,
  /**
  FeedbackMessage type (info, danger, error, warning, success)
   */
  type: PropTypes.string,
  /**
  Show an icon
   */
  icon: PropTypes.string,
  /**
  FeedbackMessage extra content
   */
  extraContent: nodeOrStringProp,
  /**
  FeedbackMessage alignment (left, center, right)
   */
  align: PropTypes.string,
  /**
  Show a close icon to remove the FeedbackMessage
   */
  closeIcon: PropTypes.bool,
  /**
  Smaller FeedbackMessage
   */
  compact: PropTypes.bool,
  /**
  Display FeedbackMessage content in columns
   */
  withColumns: PropTypes.bool,
  /**
  Show FeedbackMessage as stretch as its content
   */
  inlineBlock: PropTypes.bool,
  /**
  Function triggered clicking the FeedbackMessage
   */
  onClick: PropTypes.func,
  /**
  Function triggered closing the FeedbackMessage
   */
  onCloseClick: PropTypes.func,
  /**
  Custom className
   */
  className: PropTypes.string
};

export default FeedbackMessage;
//# sourceMappingURL=FeedbackMessage.js.map
